
export default {
    first_name: '',
    last_name: '',
    email: '',
    cell_phone: '',
    ssn: '',
    dob: '',
    address: '',
    city: '',
    postal_code: '',
    state: '',
    position: '',
    ownership_percentage: '',
    annual_income: '',
    signature_image: null,
    signature: '',
}